import React from 'react';

import contentLibraryTypeMap from 'components/Pages/Admin/PendingContent/types.js';
import { BackButtonContent } from 'components/shared/BackButtonContent';
import { PAGE_TYPE_PROPERTY, LIBRARY_CONTENT, PENDING_CONTENT, LIBRARY_RESOURCE } from 'constants/index';
import { PAGE_DETAILS_PATH, PAGE_LANDING_PATH, PAGE_RESOURCES_PATH, PAGE_ROOMS_PATH } from 'constants/routes';

// values should be the same as on the backend, do not change them if not sure
export const STEPS = {
  DETAILS: 'details',
  RESOURCES: 'resources',
  ROOMS: 'rooms',
  PAGE: 'page',
};

export const STEP_NAMES = {
  [STEPS.DETAILS]: 'Details',
  [STEPS.RESOURCES]: 'Resources',
  [STEPS.ROOMS]: 'Rooms',
  [STEPS.PAGE]: 'Page',
};

export const STEP_PATHS = {
  [STEPS.DETAILS]: PAGE_DETAILS_PATH,
  [STEPS.RESOURCES]: PAGE_RESOURCES_PATH,
  [STEPS.ROOMS]: PAGE_ROOMS_PATH,
  [STEPS.PAGE]: PAGE_LANDING_PATH,
};

export const mapLibType2BackButtonText = (libType, title, subtitle) => {
  switch (libType) {
    case LIBRARY_RESOURCE:
      return 'Back to Resource Library';
    case PENDING_CONTENT:
      return 'Back to Pending Content';
    case LIBRARY_CONTENT:
      return <BackButtonContent title={title} subtitle={`${contentLibraryTypeMap[subtitle]} Page`} />;
  }

  return null;
};

const BASE_STEPS = [STEPS.DETAILS, STEPS.PAGE];
const PAGE_TO_STEPS_MAP = {
  [PAGE_TYPE_PROPERTY]: ({ isAgent }) => [STEPS.DETAILS, !isAgent && STEPS.RESOURCES, STEPS.ROOMS, STEPS.PAGE],
};
export const mapPageType2Steps = (pageType, params) => {
  const steps = PAGE_TO_STEPS_MAP[pageType]?.(params) ?? BASE_STEPS;
  return steps.filter(Boolean);
};
